import { createApp } from 'vue';
import dJSON from 'dirty-json';
import module from './module.vue';

/**
 * Vue.js Init
 */
(() => {
  const moduleSelector = '.project-gallery-slider';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules) return;

  modules.forEach((query) => {
    try {
      const { data } = dJSON.parse(query.data);
      const componentTarget = query.querySelector('.project-gallery-slider__slider');

      createApp(module, { data }).mount(componentTarget);
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
